import { render } from "./LehrePraktika.vue?vue&type=template&id=e74baea6"
import script from "./LehrePraktika.vue?vue&type=script&lang=ts"
export * from "./LehrePraktika.vue?vue&type=script&lang=ts"

import "./LehrePraktika.vue?vue&type=style&index=0&id=e74baea6&lang=scss"
script.render = render

export default script